<template>
    <div class="main">
        <c-panel title="PONTUAÇÃO" titleIcon="fas fa-trophy">
            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Tipo">
                            <el-select v-model="tipoAtivo" @change="onTipoChange" style="width: 100%;">
                                <el-option label="Professores" value="professor"></el-option>
                                <el-option label="Alunos" value="aluno"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16">
                        <el-form-item label="Grupo de pontuação">
                            <el-select v-model="filtro.grupoId" filterable clearable @change="load" style="width: 100%;">
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" style="padding-top: 24px;" class="u-text-right">
                        <el-button @click="abrirNovo" type="primary" :disabled="!filtro.grupoId">
                            <i class="el-icon-plus"></i> NOVO LANÇAMENTO
                        </el-button>
                        <el-button @click="abrirVariaveis" type="info" plain :disabled="!filtro.grupoId">
                            <i class="el-icon-collection-tag"></i> VARIÁVEIS
                        </el-button>
                        <el-button @click="recalcular" type="warning" plain :disabled="!filtro.grupoId">
                            <i class="el-icon-refresh"></i> RECALCULAR TOTAIS
                        </el-button>
                        <el-button @click="verRanking" type="success" plain :disabled="!filtro.grupoId">
                            <i class="el-icon-data-line"></i> VER RANKING
                        </el-button>
                        <el-dropdown @command="imprimir" trigger="click" :disabled="!filtro.grupoId" style="margin-left: 10px;">
                            <el-button type="danger" plain :disabled="!filtro.grupoId">
                                <i class="el-icon-printer"></i> IMPRIMIR <i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="detalhada"><i class="el-icon-document"></i> Pontuação (detalhada)</el-dropdown-item>
                                <el-dropdown-item command="classificacao"><i class="el-icon-data-line"></i> Classificação (ranking)</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </el-form>

            <!-- Lista agrupada por pessoa -->
            <div v-if="filtro.grupoId" class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 60px;">Pos.</th>
                            <th>{{ tipoAtivo === 'professor' ? 'Servidor' : 'Aluno' }}</th>
                            <th style="width: 110px;" class="u-text-center">Nº de itens</th>
                            <th style="width: 130px;" class="u-text-right">Total</th>
                            <th style="width: 170px;" class="u-text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody v-if="status">
                        <tr v-for="(p, idx) in items" :key="p.alvo_id">
                            <td><strong>{{ idx + 1 }}º</strong></td>
                            <td>{{ p.alvo_nome }}</td>
                            <td class="u-text-center">{{ p.qtd_itens }}</td>
                            <td class="u-text-right"><strong>{{ Number(p.total).toFixed(2) }}</strong></td>
                            <td class="u-text-center">
                                <el-button @click="abrirVer(p)" size="mini" type="success" icon="el-icon-view" plain title="Visualizar"></el-button>
                                <el-button @click="abrirEditar(p)" size="mini" type="info" icon="el-icon-edit" plain title="Editar"></el-button>
                                <el-button @click="excluirPessoa(p)" size="mini" type="danger" icon="el-icon-delete" plain title="Excluir"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="5" class="u-text-center" style="padding: 20px; color: #909399;">Nenhum lançamento neste grupo.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Modal de lançamento (múltiplos itens por pessoa) -->
            <el-dialog :title="tituloModal" :visible.sync="modalVisivel" width="760px">
                <el-form label-position="top" @submit.native.prevent class="u-mt-20">
                    <el-form-item :label="tipoAtivo === 'professor' ? 'Servidor' : 'Aluno'">
                        <el-select v-if="modalModo === 'novo'" v-model="form.alvo_id" filterable remote :remote-method="searchAlvo"
                                   :loading="loadingAlvo" placeholder="Digite o nome..." style="width: 100%;">
                            <el-option v-for="a in alvos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                        </el-select>
                        <el-input v-else :value="form.alvo_nome" disabled></el-input>
                    </el-form-item>

                    <div class="u-mb-10 u-mt-10 u-text-right" v-if="modalModo !== 'ver'">
                        <el-button @click="addItem" type="primary" plain size="small" :disabled="!variaveisAtivas.length">
                            <i class="el-icon-plus"></i> ADICIONAR ITEM
                        </el-button>
                        <small v-if="!variaveisAtivas.length" style="color:#909399; margin-left: 8px;">Cadastre variáveis no botão <strong>VARIÁVEIS</strong> antes de lançar.</small>
                    </div>

                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Variável</th>
                                <th style="width: 120px;">Quantidade</th>
                                <th style="width: 110px;">Peso</th>
                                <th style="width: 100px;" class="u-text-right">Total</th>
                                <th v-if="modalModo !== 'ver'" style="width: 50px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, idx) in form.itens" :key="idx">
                                <td>
                                    <el-select v-model="item.variavel" filterable placeholder="Selecione" style="width: 100%;"
                                               :disabled="modalModo === 'ver'" @change="onItemVariavelChange(item, $event)">
                                        <el-option v-for="o in opcoesVariaveis(item)" :key="o.nome" :label="o.nome" :value="o.nome"></el-option>
                                    </el-select>
                                </td>
                                <td>
                                    <el-input-number v-model="item.quantidade" :min="0" :precision="2" :step="1" :controls="false"
                                                     :disabled="modalModo === 'ver'" style="width: 100%;"></el-input-number>
                                </td>
                                <td>
                                    <el-input-number v-model="item.peso" :min="0" :precision="2" :step="0.5" :controls="false"
                                                     :disabled="modalModo === 'ver'" style="width: 100%;"></el-input-number>
                                </td>
                                <td class="u-text-right"><strong>{{ (Number(item.quantidade || 0) * Number(item.peso || 0)).toFixed(2) }}</strong></td>
                                <td v-if="modalModo !== 'ver'" class="u-text-center">
                                    <el-button @click="removerItem(idx)" size="mini" type="danger" icon="el-icon-delete" plain circle></el-button>
                                </td>
                            </tr>
                            <tr v-if="!form.itens.length">
                                <td :colspan="modalModo === 'ver' ? 4 : 5" class="u-text-center" style="padding: 16px; color: #909399;">Nenhum item. Clique em ADICIONAR ITEM.</td>
                            </tr>
                        </tbody>
                        <tfoot v-if="form.itens.length">
                            <tr>
                                <td colspan="3" class="u-text-right"><strong>Total geral</strong></td>
                                <td class="u-text-right"><strong style="color:#409eff; font-size: 16px;">{{ totalGeral.toFixed(2) }}</strong></td>
                                <td v-if="modalModo !== 'ver'"></td>
                            </tr>
                        </tfoot>
                    </table>
                </el-form>
                <span slot="footer">
                    <el-button @click="modalVisivel = false">{{ modalModo === 'ver' ? 'Fechar' : 'Cancelar' }}</el-button>
                    <el-button v-if="modalModo !== 'ver'" type="primary" @click="salvarLote">SALVAR</el-button>
                </span>
            </el-dialog>

            <!-- Modal de ranking -->
            <el-dialog title="Ranking do grupo" :visible.sync="modalRankingVisivel" width="70%">
                <el-form v-if="porEscola && tipoAtivo === 'professor'" label-position="top" class="u-mb-10" @submit.native.prevent>
                    <el-form-item label="Instituição (ranking por escola)">
                        <el-select v-model="rankingInstituicaoId" filterable placeholder="Selecione a instituição" style="width: 100%;" @change="carregarRanking">
                            <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <div v-if="porEscola && tipoAtivo === 'professor' && !rankingInstituicaoId" class="u-text-center" style="padding: 20px; color: #909399;">
                    Selecione a instituição para ver o ranking.
                </div>
                <table v-else class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 60px;">Pos.</th>
                            <th>{{ tipoAtivo === 'professor' ? 'Servidor' : 'Aluno' }}</th>
                            <th style="width: 120px;" class="u-text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(r, idx) in ranking" :key="r.alvo_id">
                            <td><strong>{{ idx + 1 }}º</strong></td>
                            <td>{{ r.alvo_nome }}</td>
                            <td class="u-text-right"><strong>{{ Number(r.total).toFixed(2) }}</strong></td>
                        </tr>
                        <tr v-if="!ranking.length">
                            <td colspan="3" class="u-text-center" style="padding: 20px; color: #909399;">Sem lançamentos.</td>
                        </tr>
                    </tbody>
                </table>
                <span slot="footer">
                    <el-button @click="modalRankingVisivel = false">Fechar</el-button>
                    <el-button type="danger" plain @click="imprimirClassificacao"><i class="el-icon-printer"></i> IMPRIMIR</el-button>
                </span>
            </el-dialog>

            <!-- Modal de variáveis do grupo -->
            <el-dialog title="Variáveis do grupo" :visible.sync="modalVariaveisVisivel" width="640px">
                <el-form label-position="top" @submit.native.prevent class="u-mt-20">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Nome da variável">
                                <el-input v-model="formVar.nome" placeholder="Ex.: Especialização"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6">
                            <el-form-item label="Peso padrão">
                                <el-input-number v-model="formVar.peso_padrao" :min="0" :precision="2" :step="0.5" style="width: 100%;"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6" style="padding-top: 30px;">
                            <el-button @click="salvarVar" type="primary" style="width: 100%;">
                                {{ formVar.id ? 'SALVAR' : 'ADICIONAR' }}
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-form-item v-if="formVar.id">
                        <el-switch v-model="formVar.situacao" active-text="Ativa" inactive-text="Inativa"></el-switch>
                        <el-button @click="resetFormVar" size="mini" plain style="margin-left: 12px;">cancelar edição</el-button>
                    </el-form-item>
                </el-form>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Variável</th>
                            <th style="width: 110px;" class="u-text-right">Peso padrão</th>
                            <th style="width: 90px;" class="u-text-center">Situação</th>
                            <th style="width: 110px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="v in variaveis" :key="v.id">
                            <td>{{ v.nome }}</td>
                            <td class="u-text-right">{{ Number(v.peso_padrao).toFixed(2) }}</td>
                            <td class="u-text-center">
                                <el-tag :type="v.situacao ? 'success' : 'info'" size="mini">{{ v.situacao ? 'Ativa' : 'Inativa' }}</el-tag>
                            </td>
                            <td class="u-text-center">
                                <el-button @click="abrirEditarVar(v)" size="mini" type="info" icon="el-icon-edit" plain></el-button>
                                <el-button @click="excluirVar(v.id)" size="mini" type="danger" icon="el-icon-delete" plain></el-button>
                            </td>
                        </tr>
                        <tr v-if="!variaveis.length">
                            <td colspan="4" class="u-text-center" style="padding: 20px; color: #909399;">Nenhuma variável cadastrada neste grupo.</td>
                        </tr>
                    </tbody>
                </table>
            </el-dialog>
        </c-panel>
    </div>
</template>

<script>
const FORM_VAR_VAZIO = { id: null, nome: '', peso_padrao: 1, situacao: true }
const novoItem = () => ({ id: null, variavel: '', quantidade: 0, peso: 1 })

export default {
    data: () => ({
        tipoAtivo: 'professor',
        grupos: [],
        filtro: { grupoId: null },
        items: [],
        status: false,
        modalVisivel: false,
        modalModo: 'novo', // novo | editar | ver
        modalRankingVisivel: false,
        form: { alvo_id: null, alvo_nome: '', itens: [] },
        loadingAlvo: false,
        alvos: [],
        ranking: [],
        porEscola: false,
        rankingInstituicaoId: '',
        variaveis: [],
        modalVariaveisVisivel: false,
        formVar: { ...FORM_VAR_VAZIO }
    }),
    computed: {
        instituicoes () { return this.$store.state.instituicoes || [] },
        variaveisAtivas () { return this.variaveis.filter(v => v.situacao) },
        tituloModal () {
            if (this.modalModo === 'ver') return 'Visualizar lançamento'
            if (this.modalModo === 'editar') return 'Editar lançamento'
            return 'Novo lançamento'
        },
        totalGeral () {
            return this.form.itens.reduce((s, it) => s + (Number(it.quantidade || 0) * Number(it.peso || 0)), 0)
        }
    },
    mounted () { this.carregarGrupos(); this.carregarParametroPorEscola() },
    methods: {
        endpointGrupos () {
            return this.tipoAtivo === 'professor' ? 'grupo-pontuacao-professor' : 'grupo-pontuacao-aluno'
        },
        endpointAlvoSearch () {
            return this.tipoAtivo === 'professor' ? 'servidor/searchByNome' : 'aluno/searchByNome'
        },
        onTipoChange () {
            this.filtro.grupoId = null
            this.items = []
            this.variaveis = []
            this.carregarGrupos()
            this.carregarParametroPorEscola()
        },
        carregarParametroPorEscola () {
            // Só o ranking de professor é afetado pelo parâmetro "por escola".
            if (this.tipoAtivo !== 'professor') { this.porEscola = false; return }
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/parametro-sistema/getValor/professor.pontuacao_por_escola`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.porEscola = !!(r.data && r.data.valor) })
              .catch(() => { this.porEscola = false })
        },
        carregarGrupos () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/${this.endpointGrupos()}/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.grupos = r.data || [] })
              .catch(() => { this.grupos = [] })
        },
        load () {
            if (!this.filtro.grupoId) { this.items = []; this.variaveis = []; return }
            this.carregarVariaveis()
            this.status = false
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/pontuacao/agrupado/${this.tipoAtivo}/${this.filtro.grupoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.items = r.data || []
                this.status = true
            }).catch(e => { this.status = true; this.$store.commit('throwException', e) })
        },
        searchAlvo (query) {
            if (!query) { this.alvos = []; return }
            this.loadingAlvo = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/${this.endpointAlvoSearch()}`,
                { query: query },
                this.$store.getters.getHeaderAuth
            ).then(r => { this.alvos = r.data || [] })
              .catch(() => {})
              .finally(() => { this.loadingAlvo = false })
        },
        opcoesVariaveis (item) {
            const arr = this.variaveisAtivas.map(v => ({ nome: v.nome, peso_padrao: v.peso_padrao }))
            // inclui o valor atual do item se não estiver na lista (dado antigo em texto livre)
            if (item && item.variavel && !arr.some(o => o.nome === item.variavel)) {
                arr.unshift({ nome: item.variavel, peso_padrao: null })
            }
            return arr
        },
        onItemVariavelChange (item, nome) {
            const v = this.variaveisAtivas.find(x => x.nome === nome)
            if (v && v.peso_padrao !== null && v.peso_padrao !== undefined) item.peso = Number(v.peso_padrao)
        },
        addItem () { this.form.itens.push(novoItem()) },
        removerItem (idx) { this.form.itens.splice(idx, 1) },
        abrirNovo () {
            this.modalModo = 'novo'
            this.alvos = []
            this.form = { alvo_id: null, alvo_nome: '', itens: [novoItem()] }
            this.modalVisivel = true
        },
        abrirEditar (p) { this.modalModo = 'editar'; this.abrirComPessoa(p) },
        abrirVer (p) { this.modalModo = 'ver'; this.abrirComPessoa(p) },
        abrirComPessoa (p) {
            this.form = {
                alvo_id: p.alvo_id,
                alvo_nome: p.alvo_nome,
                itens: (p.itens || []).map(it => ({ id: it.id, variavel: it.variavel, quantidade: Number(it.quantidade), peso: Number(it.peso) }))
            }
            this.modalVisivel = true
        },
        salvarLote () {
            if (!this.form.alvo_id) { window.eventBus.$emit('alert', { msg: 'Selecione a pessoa.', type: 'warning' }); return }
            if (!this.form.itens.length) { window.eventBus.$emit('alert', { msg: 'Adicione ao menos um item.', type: 'warning' }); return }
            if (this.form.itens.some(it => !it.variavel)) { window.eventBus.$emit('alert', { msg: 'Todos os itens precisam de uma variável.', type: 'warning' }); return }

            const payload = {
                grupo_id: this.filtro.grupoId,
                alvo_id: this.form.alvo_id,
                itens: this.form.itens.map(it => ({ id: it.id, variavel: it.variavel, quantidade: it.quantidade, peso: it.peso }))
            }
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/pontuacao/salvarLoteAlvo/${this.tipoAtivo}`,
                payload, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: 'Salvo.', type: 'success' })
                this.modalVisivel = false
                this.load()
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluirPessoa (p) {
            this.$msgbox.confirm(`Excluir todos os lançamentos de ${p.alvo_nome}?`, 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/pontuacao/deletePorAlvo/${this.tipoAtivo}/${this.filtro.grupoId}/${p.alvo_id}`,
                    this.$store.getters.getHeaderAuth
                ).then(() => { this.load() })
            }).catch(() => {})
        },
        recalcular () {
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/pontuacao/recalcularTotaisGrupo/${this.tipoAtivo}/${this.filtro.grupoId}`,
                {},
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('alert', { msg: `Recalculado: ${r.data.linhas} linhas.`, type: 'success' })
                this.load()
            })
        },
        // ---- Variáveis do grupo ----
        carregarVariaveis () {
            if (!this.filtro.grupoId) { this.variaveis = []; return }
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/variavel-pontuacao/listar/${this.tipoAtivo}/${this.filtro.grupoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.variaveis = r.data || [] })
              .catch(() => { this.variaveis = [] })
        },
        abrirVariaveis () {
            this.resetFormVar()
            this.carregarVariaveis()
            this.modalVariaveisVisivel = true
        },
        resetFormVar () { this.formVar = { ...FORM_VAR_VAZIO } },
        abrirEditarVar (v) {
            this.formVar = { id: v.id, nome: v.nome, peso_padrao: Number(v.peso_padrao), situacao: !!v.situacao }
        },
        salvarVar () {
            if (!this.formVar.nome) {
                window.eventBus.$emit('alert', { msg: 'Informe o nome da variável.', type: 'warning' })
                return
            }
            const payload = {
                grupo_id: this.filtro.grupoId,
                nome: this.formVar.nome,
                peso_padrao: this.formVar.peso_padrao,
                situacao: this.formVar.situacao
            }
            const url = this.formVar.id
                ? `${this.$store.state.config.baseUrlApi}/api/variavel-pontuacao/update/${this.tipoAtivo}/${this.formVar.id}`
                : `${this.$store.state.config.baseUrlApi}/api/variavel-pontuacao/store/${this.tipoAtivo}`
            this.$axios.post(url, payload, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: r.data.erro, type: 'warning' })
                    return
                }
                window.eventBus.$emit('alert', { msg: 'Salvo.', type: 'success' })
                this.resetFormVar()
                this.carregarVariaveis()
            }).catch(e => this.$store.commit('throwException', e))
        },
        excluirVar (id) {
            this.$msgbox.confirm('Excluir esta variável?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                this.$axios.delete(
                    `${this.$store.state.config.baseUrlApi}/api/variavel-pontuacao/delete/${this.tipoAtivo}/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(() => { this.carregarVariaveis() })
            }).catch(() => {})
        },
        verRanking () {
            // Ranking por escola: pré-seleciona a instituição do usuário (se houver).
            if (this.porEscola && this.tipoAtivo === 'professor' && !this.rankingInstituicaoId) {
                const inst = this.$store.state.config.instituicao
                this.rankingInstituicaoId = inst && inst.id ? inst.id : ''
            }
            this.ranking = []
            this.modalRankingVisivel = true
            this.carregarRanking()
        },
        carregarRanking () {
            // No modo por escola, só carrega quando uma instituição estiver selecionada.
            const porEscolaProf = this.porEscola && this.tipoAtivo === 'professor'
            if (porEscolaProf && !this.rankingInstituicaoId) { this.ranking = []; return }

            let url = `${this.$store.state.config.baseUrlApi}/api/pontuacao/ranking/${this.tipoAtivo}/${this.filtro.grupoId}`
            if (porEscolaProf) url += `?instituicao_id=${this.rankingInstituicaoId}`

            this.$axios.get(url, this.$store.getters.getHeaderAuth).then(r => {
                const data = r.data || {}
                // resposta nova: { por_escola, itens }; fallback para array antigo
                this.ranking = Array.isArray(data) ? data : (data.itens || [])
                if (data && typeof data.por_escola !== 'undefined') this.porEscola = data.por_escola
            }).catch(e => this.$store.commit('throwException', e))
        },
        imprimir (comando) {
            const param = { tipo: this.tipoAtivo, grupo_id: this.filtro.grupoId }
            const url = comando === 'detalhada'
                ? '/api/pontuacao-relatorio/detalhada'
                : '/api/pontuacao-relatorio/classificacao'
            window.eventBus.$emit('print', { url, param })
        },
        imprimirClassificacao () {
            // do modal de ranking: respeita a instituição selecionada (modo por escola)
            const param = { tipo: this.tipoAtivo, grupo_id: this.filtro.grupoId }
            if (this.porEscola && this.tipoAtivo === 'professor' && this.rankingInstituicaoId) {
                param.instituicao_id = this.rankingInstituicaoId
            }
            window.eventBus.$emit('print', { url: '/api/pontuacao-relatorio/classificacao', param })
        }
    }
}
</script>
